"use client";

import NextError from "next/error";
import { useEffect } from "react";
import { addCustomError } from "../observability/datadogRum";
import { sdkLogger } from "../utils/logger";

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
}) {
  useEffect(() => {
    sdkLogger.error("global_error_caught", {
      error: error.message,
      stack: error.stack,
      digest: error.digest,
    });
    // Track error with Datadog RUM
    addCustomError(error, {
      error_type: "global_error",
      error_digest: error.digest,
      flow: "whatsapp_business_signup",
    });
  }, [error]);

  return (
    <html lang="en">
      <body>
        {/* `NextError` is the default Next.js error page component. Its type
        definition requires a `statusCode` prop. However, since the App Router
        does not expose status codes for errors, we simply pass 0 to render a
        generic error message. */}
        <NextError statusCode={0} />
      </body>
    </html>
  );
}
